import arrow from "../../images/svg/arrow.svg";
import { userDataState} from "../../atoms/dashboard";
import { useRecoilValue  } from "recoil";
import noFound from "../../images/svg/no_found.svg";
import { MycarUrl } from "../../selectors/baseurl";
const JobRole = (props) => {
  console.log(props);
  const usrData = useRecoilValue(userDataState);
  console.log(usrData);
  console.log(props?.data?.divisionName,usrData.divisionName);
  if (usrData?.isLogged == false) window.location.href = MycarUrl;
  return (
    <>
    {props?.data?.level && 
       <div
        className={`border-2 relative ${( props?.data?.divisionName != usrData?.divisionName) ? 'border-[#c9407f]' :"border-blue-500"} rounded-[15px] p-3 ${props?.arr.length < 4 && 'w-[375px]'} ${
          !props?.isDetailsRequired ? "pb-8" : "pb-0"
        } pb-[30px] ${!props?.isDetailsRequired && 'w-[280px]'} mt-2 h-[130px]`}
      >
        <div>
          <h2 className="text-[0.8rem]">{props?.data?.level+'-'+(props?.data?.jobPosition ? props?.data?.jobPosition : "")}</h2>
          <h3 className="mt-2 text-[0.9rem] text-black font-bold">
            {props?.data?.divisionName}
          </h3>
          <h4 className="mt-1 text-[0.8rem] text-gray-600 font-semibold opacity-80">
            {props?.data?.streamName+'-'+props?.data?.subStreamName}
          </h4>
        </div>
        {props?.isDetailsRequired && (
          <span className="flex items-end justify-end cursor-pointer absolute right-0 bottom-0">
            <span
              onClick={() => props?.callback(props?.valsid)}
              className="bg-[#418aff] py-1 px-[20px] text-white text-[11px] tracking-[1px] rounded-br-[12px] rounded-tl-lg flex items-center justify-center gap-2 uppercase"
            >
              Details
              <span>
                <img style={{width:"12px"}} className="" src={arrow} alt="arrow svg" />
              </span>
            </span>
          </span>
        )}
      </div>
      }
      {props?.data?.level == undefined && 
      <div
      className={`border-2 relative border-[#808080] rounded-[15px] p-3 ${props?.arr.length < 4 && 'w-[375px]'} ${
        !props?.isDetailsRequired ? "pb-8" : "pb-0"
      } pb-[30px] ${!props?.isDetailsRequired && 'w-[280px]'} mt-2`}
    >    
    <div className="flex flex-col items-center my-4">
     <img src={noFound} alt="no found" width={34} height={34} />
     <p className="font-bold mt-3">NO MATCH FOUND !!!</p>
     </div>
    </div>
      }
    </>
  );
};

export default JobRole;
